import Cookies from 'js-cookie';
import ConfigJSON from '../../config.json';
import './navigo/navigo';

jQuery(document).ready(function ($) {
    // Company accordion. Header click
    $('.lk-content-wrapper .orders-wrapper').on('click', '.company-list .cli__title', function (e) {
        e.preventDefault();

        $(this).parent().toggleClass('active');
        $(this).siblings('.orders-list').toggle();
    });

    // Documents accordion. Header click
    $('.lk-content-wrapper .documents-wrapper .orders-list .oli__title').on('click', function (e) {
        e.preventDefault();

        $(this).parent().toggleClass('active');
        $(this).siblings('.documents-list').toggle();
    });

    // Click on back button on info panel
    $('.lk-content-wrapper .orders-info-wrapper .orders-info__back').on('click', function (e) {
        e.preventDefault();

        if (window.innerWidth < ConfigJSON.desktopBreakWidth) {
            $('.lk-content-wrapper .orders-info-wrapper').hide();
            $('.lk-content-wrapper .orders-wrapper').show();
        }
    });

    // Click on back button on documents list
    $('.lk-content-wrapper .documents-wrapper .documents-wrapper__back').on('click', function (e) {
        e.preventDefault();

        $('.lk-content-wrapper .documents-wrapper').hide();
        $('.lk-content-wrapper .document-info-wrapper').hide();
        $('.lk-content-wrapper .orders-info-wrapper').show();

        if (window.innerWidth >= ConfigJSON.desktopBreakWidth) {
            $('.lk-content-wrapper .orders-wrapper').show();
            $('.lk-content-wrapper .orders-info-wrapper').show();
        }
    });

    // Click on back button on documents list
    $('.lk-content-wrapper .document-info-wrapper .documents-wrapper__back').on('click', function (e) {
        e.preventDefault();

        $('.lk-content-wrapper .documents-wrapper').show();
        $('.lk-content-wrapper .document-info-wrapper').hide();
    });

    // Click on document
    $('.lk-content-wrapper .documents-list').on('click', '.documents-list__item', function (e) {
        e.preventDefault();

        let pdfUrl = $(this).find('.dli__text').attr('data-doc-url');

        //if ($('.lk-content-wrapper .document-info-wrapper object') && (pdfUrl != $('.lk-content-wrapper .document-info-wrapper object').attr('data'))) {
        $('.lk-content-wrapper .document-info-wrapper object').remove();
        //}

        if (window.innerWidth < ConfigJSON.desktopBreakWidth) {
            $('.lk-content-wrapper .documents-wrapper').hide();
            $('.lk-content-wrapper .document-info-wrapper').show();
        } else {
            $('.lk-content-wrapper .document-info-wrapper').show();
        }

        if ($('.lk-content-wrapper .document-info-wrapper object') && (pdfUrl != $('.lk-content-wrapper .document-info-wrapper object').attr('data'))) {
            $('.lk-content-wrapper .document-info-wrapper').append(`
                <object type="application/pdf" data="${pdfUrl}" style="width:100%; height:100%;">
                    <p>This browser does not support PDFs. Please download the PDF to view it: <a class="fallback-url" href="${pdfUrl}">Download PDF</a>.</p>
                </object>
            `);
        }
    });

    // logout
    $('.lk-sidebar a.lk-sidebar__menu-logout, .footer-nav .log-out').on('click', function (e) {
        e.preventDefault();

        Cookies.remove('lk-bearer');
        window.location = '/my-account/login'
    });

    $('.acc-info-wrapper .edit-mark').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.lk-input__text-field').removeAttr('readonly').attr('placeholder', '').focus();
    });
});